<a rds-link standalone size="m" bshNavigateBack class="back-nav">
  <rds-icon namespace="filled" icon="arrow_left"></rds-icon>
  Go back
</a>

@let roomData = roomDetails();

@if (roomData) {
  @if (
    !roomData.manageSpace &&
    !(roomData.externalServiceUrl && roomData.externalServiceName)
  ) {
    <div class="g-cal-warning">
      <rds-alert
        >This room is bookable and managed via Google Calendar, not by Bookly.
        Any meeting created for this room will only be visible in your Google
        Calendar.</rds-alert
      >
    </div>
  }
  <div class="header-wrapper">
    <p class="ui-heading-1-bold">{{ roomData.roomName }}</p>
    <div class="buttons">
      <div>
        @if (roomData.externalServiceUrl && roomData.externalServiceName) {
          <button rds-primary-button size="l" (click)="redirectToExternal()">
            <rds-icon icon="calendar" namespace="filled" />
            {{ roomData.externalServiceName }}
          </button>
        } @else if (roomData.manageSpace) {
          <button
            rds-primary-button
            size="l"
            routerLink="../{{ roomData.roomDexId }}/create">
            <rds-icon icon="calendar" namespace="filled" />
            Request event
          </button>
        } @else {
          <button rds-primary-button size="l" (click)="navigateToCalendar()">
            <rds-icon icon="calendar" namespace="filled" />
            Book via Google Calendar
          </button>
        }
        @if (!roomData.active) {
          <div class="warning-container">
            <rds-icon icon="warning_triangle" namespace="outlined" />
            <p class="ui-component-text-s">Selected room is not active</p>
          </div>
        }
        @if (roomData.semiPrivate) {
          <div class="warning-container">
            <rds-icon icon="warning_triangle" namespace="outlined" />
            <p class="ui-component-text-s">
              Visibility for this room in Bookly is restricted to users with
              authorized calendar access.
            </p>
          </div>
        }
      </div>
      <div class="favorite-btn">
        <button
          rds-secondary-button
          size="l"
          [disabled]="isFavoriteLoading()"
          (click)="toggleFavorite()">
          @if (isFavoriteLoading()) {
            <rds-progress-spinner size="s" />
          } @else if (isFavorite()) {
            <rds-icon namespace="filled" icon="heart" />
          } @else {
            <rds-icon namespace="outlined" icon="heart" />
          }
        </button>
      </div>
    </div>
  </div>

  <rds-tabs ariaLabel="Room details tabs">
    <rds-tab label="Details">
      <div class="card-container">
        <bus-room-details-card
          [roomDetails]="roomData"
          [roomLayouts]="roomLayouts()"></bus-room-details-card>
      </div>
    </rds-tab>
    @if (!(roomData.externalServiceUrl && roomData.externalServiceName)) {
      <rds-tab label="Calendar">
        <div class="calendar-container">
          <bsh-room-bookings-calendar
            [calendarData]="{
              semiPrivate: roomData.semiPrivate,
              roomCalendarId: roomData.calendarId,
              startDate: filters.fromDate,
            }"
            (dateSelected)="
              redirectToDate($event)
            "></bsh-room-bookings-calendar>
        </div>
      </rds-tab>
    }
  </rds-tabs>
}

@if (isLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
}
